import { api } from "roboflex-thalamus-request-handler";

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos

let cachePayload = null;
let cacheTimestamp = 0;
let inflight = null;

/**
 * Usuários + setores hierárquicos (cache em memória, zera no F5).
 */
export async function consultarSetores() {
    if (cachePayload && Date.now() - cacheTimestamp < CACHE_TTL_MS) {
        return {
            usuarios: cachePayload.usuarios,
            setores: cachePayload.setores,
        };
    }

    if (inflight) {
        return inflight;
    }

    inflight = (async () => {
        try {
            const responseUsuarios = await api.get(`usuario`);
            const usuarios = responseUsuarios.data.map(item => ({
                id: item.id,
                nomeCompleto: item.name,
            }));

            const responseSetores = await api.get(`/setor/hierarquico`);
            const setores = flattenHierarchy(responseSetores.data);

            cachePayload = { usuarios, setores };
            cacheTimestamp = Date.now();

            return {
                usuarios: cachePayload.usuarios,
                setores: cachePayload.setores,
            };
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        } finally {
            inflight = null;
        }
    })();

    return inflight;
}

function flattenHierarchy(data) {
    var setores = [];

    data.forEach(item => {
        if (item.nivel_hierarquico <= 3) {
            setores.push({ id: item.id, nome: item.nome, nivel_hierarquico: item.nivel_hierarquico, responsavel_id: item.responsavel_id, pessoas: item.pessoas });
        }

        if (item.subsetor.length > 0) {
            setores = setores.concat(flattenHierarchy(item.subsetor));
        }
    });

    return setores;
}
